import { isDate } from "./domain";
export type Period = "month" | "year" | "all" | "custom";
export type ReportScope =
  "sales" | "received" | "outstanding" | "overdue" | "undated";
export type OverviewQuery = {
  period: Period;
  from?: string;
  to?: string;
  scope?: ReportScope;
  client?: string;
  clientName?: string;
};
export const defaultOverview: OverviewQuery = { period: "month" };
export function periodRange(q: OverviewQuery, today: string) {
  if (q.period === "all") return { from: "2000-01-01", to: "2100-12-31" };
  if (q.period === "year")
    return {
      from: today.slice(0, 4) + "-01-01",
      to: today.slice(0, 4) + "-12-31",
    };
  if (q.period === "custom") {
    if (!q.from || !q.to || !isDate(q.from) || !isDate(q.to) || q.from > q.to)
      throw new Error("Choose a valid start and end date.");
    return { from: q.from, to: q.to };
  }
  const last = new Date(
    Date.UTC(Number(today.slice(0, 4)), Number(today.slice(5, 7)), 0),
  )
    .toISOString()
    .slice(0, 10);
  return { from: today.slice(0, 7) + "-01", to: last };
}
export type ReportRow = {
  id: string;
  number: string;
  clientName: string;
  issueDate: string;
  dueDate: string;
  amountPence: number;
  status: string;
  paymentDate?: string | null;
};
export type Payment = {
  id: string;
  amountPence: number;
  receivedDate: string | null;
  source: string;
};
export type OverviewData = {
  range: { from: string; to: string };
  chartRange: { from: string; to: string };
  today: string;
  salesPence: number;
  invoiceCount: number;
  vatPence: number;
  receivedPence: number;
  undatedPence: number;
  outstandingPence: number;
  overduePence: number;
  outstandingCount: number;
  overdueCount: number;
  months: { month: string; netPence: number }[];
  firstDate: string | null;
  lastDate: string | null;
  customers: { id: string; name: string; netPence: number; count: number }[];
  overdue: ReportRow[];
};
export function overviewSearch(q: OverviewQuery) {
  const p = new URLSearchParams({ period: q.period });
  for (const key of ["from", "to", "scope", "client", "clientName"] as const)
    if (q[key]) p.set(key, q[key]!);
  return p.toString();
}
